import React, { Component } from "react";
import { connect } from "react-redux";
import {
  BASE_IMAGES_URL,
  ACCESS_FILES_API_KEY,
  COMMON_FAIL_MESSAGE,
} from "Constants";

import LocaleStrings from "Languages";

class FooterList extends Component {
  constructor(props) {
    super(props);
 
  }
  viewfooterSite = (e) => {
    let siteURL ="http://staging.teks.co.in/udayan/preview/footer/index.php";
      // "https://" + siteDetails.resource[0].website_subdomain + ".eventify.io";
    window.open(siteURL, "_blank");
  };


  render() {
    var { values } = this.props;

    return (
      <tr>
        {/*<td>{speaker.speakerid}</td>*/}
        <td>
          <div className="row">
            <div className="col-md-12 col-lg-12 d-flex">
              Footer
            </div>
          </div>
        </td>
        <td>

        </td>

        <td>

        </td>
        <td>
          <div className="action-button-area" style={{ display: "flex" }}>
            <div className="action-button">
              <button
                className="btn btn-custom-table-white"
                // onClick={() => this.openModals("newpagepreview")}
                onClick={(e) => this.viewfooterSite()}
              >
                Preview Footer
              </button>
            </div>
          </div>
        </td>
      </tr>
    
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
})(FooterList);
